export function isNotFalse<T>(value: T | false): value is T {
  return value !== false;
}
